import { useEffect, useRef, useState } from "react";
import { CartIcon } from "./icons/CartIcon";

interface Props {
  onClick: () => void;
  itemCount: number;
  /** Total cart amount — kept in the API for future use; not displayed in the compact layout. */
  total: number;
}

export const CartTriggerButton = ({ onClick, itemCount, total }: Props): JSX.Element => {
  const empty = itemCount === 0;
  const [pulse, setPulse] = useState(false);
  const prev = useRef(itemCount);

  useEffect(() => {
    if (itemCount > prev.current) {
      setPulse(true);
      const t = window.setTimeout(() => setPulse(false), 250);
      prev.current = itemCount;
      return () => clearTimeout(t);
    }
    prev.current = itemCount;
  }, [itemCount]);

  void total; // intentionally unused in the compact layout

  return (
    <button
      type="button"
      onClick={onClick}
      data-cart-trigger=""
      aria-label={
        empty ? "Panier vide" : `Voir le panier, ${itemCount} article${itemCount > 1 ? "s" : ""}`
      }
      className={`relative w-12 h-12 rounded-full flex items-center justify-center transition-transform duration-200 bg-primary text-white ring-4 ring-surface shadow-[0_10px_28px_-8px_rgba(200,85,61,0.6)] ${
        empty ? "opacity-70" : ""
      } ${pulse ? "scale-110" : "scale-100"}`}
    >
      <CartIcon />
      {itemCount > 0 && (
        <span
          aria-hidden="true"
          className="absolute -top-2 -right-2 min-w-[26px] h-[26px] px-1.5 rounded-full bg-warm text-ink text-sm font-bold flex items-center justify-center ring-2 ring-surface shadow-warm-sm tabular-nums"
        >
          {itemCount > 99 ? "99+" : itemCount}
        </span>
      )}
    </button>
  );
};
